import { Container, Row, Col, Button } from "react-bootstrap";
import BookingFilters from "../../components/bookingHistory/BookingFilters";
import BookingTable from "../../components/dashboard/BookingTable";
import BookingStats from "../../components/bookingHistory/BookingStats";

export default function BookingHistory() {

      const statsData = [
    {
      title: "Total Bookings",
      value: 37,
      icon: "calendar",
      color: "#2563eb",
      bg: "#eaf2ff",
    },
    {
      title: "Completed",
      value: 28,
      percent: "75.7%",
      icon: "check",
      color: "#16a34a",
      bg: "#eafaf1",
    },
    {
      title: "Upcoming",
      value: 5,
      percent: "13.5%",
      icon: "clock",
      color: "#f59e0b",
      bg: "#fff7e6",
    },
    {
      title: "Cancelled",
      value: 4,
      percent: "10.8%",
      icon: "close",
      color: "#ef4444",
      bg: "#feecec",
    },
    {
      title: "No Show",
      value: 2,
      percent: "5.4%",
      icon: "calendar-x",
      color: "#7c3aed",
      bg: "#f3e8ff",
    },
  ];


    return (
        <Container fluid className="mv-page">

            {/* HEADER */}
            <div className="mv-header">
                <div>
                    <h3>Booking history</h3>
                    <p>View and search all booking reservations.</p>
                </div>

                <Button className="mv-add-btn">+ Generate Gate Code</Button>
            </div>

            <BookingStats data={statsData} />

            {/* FILTERS */}
            <BookingFilters />

            {/* TABLE */}
            <BookingTable />

        </Container>
    );
}